export default "__VITE_ASSET__lh1bJP7L__"